module.exports = __webpack_public_path__ + "img/unitedarabemirates.e22164b5.svg";